import { createRefPath } from 'global/firestoreData/appData/appRefPaths'
import { useCallback, useContext } from 'react'
import { AppSettingsContext } from '../AppSettingsContext'
import { DatabaseContext } from '../DatabaseContext'
import { useFunctions } from './useFunctions'

export const useAppForms = () => {

  const { fn_cls } = useFunctions()

  const databaseContext = useContext(DatabaseContext)
  const { database_fns } = databaseContext ?? {}

  const appSettingsContext = useContext(AppSettingsContext)
  const { appSettings_handlers } = appSettingsContext ?? {}

  const getAppForms = useCallback(async ({ callback }) => {
    const vvProps = []
    const cb = (res) => {
      const { error } = res;
      if (error) {
        appSettings_handlers.handleError_app(error);
      } else {
        callback({ allAppForms: res })
        // setAppForms(res);
      }
    };
    get_appForms(fn_cls, database_fns, cb, vvProps);
  }, []);

  return { getAppForms }
}

// *************************

const get_appForms = (fn_cls, database_fns, callback, vvProps) => {
  const docName = 'appForms'
  database_fns.get_data({ refPath: createRefPath(['_appForms', docName]), opts: { returnFirstObject: true, ignoreId: true } }).then(appForms => {
    const { error } = appForms ?? {}
    if (error) {
      callback(error)
    } else {
      if (appForms && Object.keys(appForms).length === 0) {
        fn_cls.getAppForms(vvProps).then(appForms => {
          callback(appForms)
        })
      } else {
        callback(appForms ?? {})
      }
    }
  }).catch(err => {
    console.error('getAppForms', err)
    callback({ error: err })
  })
}